import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import StartVTC from './StartVTC';

const SessionStartVTC = observer(class SessionStartVTC extends React.Component {
  constructor() {
    super();
    this.setAccessCode = this.setAccessCode.bind(this);
  }

  componentWillMount() {
    this.state = {
      accessCode: null
    }

    const { examSid, sessionSid } = this.props;

    this.props.store.ExamStore.getExam(examSid);
    this.props.store.ExamStore.getExamSession(examSid, sessionSid, this.setAccessCode);
  }

  setAccessCode(response) {
    this.setState({
      accessCode: response.data.accessKey
    });
  }

  render() {
    const { store, translation } = this.props;
    const { ExamStore, SessionStore } = store;
    const { exam, examSession } = ExamStore;

    if(!SessionStore.loading && exam && examSession.examConfiguration) {
      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          <StartVTC
            accessCode={this.state.accessCode}
            {...this.props}
          />
        </div>
      )
    }

    return null
  }
})

export default translate('SessionStartVTC')(SessionStartVTC);


// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/SessionStartVTC.js